<template>
	<div>
		<b-card no-body class="p-1 mr-1">
			<b-tabs nav-class="m-0">
				<b-tab
					v-for="area in areaTabs"
					:key="`areax-${area.id}`"
					:title="area.name"
					@click="changeArea(area.id)"
				></b-tab>
			</b-tabs>
		</b-card>
		<b-card class="p-1 mr-1" no-body>
			<b-tabs v-model="tabIndex">
				<b-tab v-for="tab in tabs" :key="`tabx-${tab.id}`" :title="tab.name">
					<b-row class="mb-1">
						<b-col class="d-flex justify-content-end">
							<b-button
								class="d-inline text-nowrap"
								variant="outline-primary"
								@click="handleOpenCreationModal(tab.id)"
							>
								<FeatherIcon icon="PlusIcon" size="20" />
							</b-button>
						</b-col>
					</b-row>
					<b-row class="mb-1">
						<b-col class="d-flex align-items-center">
							<small class="text-secondary">
								Mostrando {{ pagination.from }} a {{ pagination.to }} de
								{{ pagination.total }} registros
							</small>
						</b-col>
						<b-col class="d-flex align-items-center justify-content-end flex-wrap gap-x-4 gap-y-1">
							<b-pagination
								v-model="pagination.curPage"
								:total-rows="pagination.total"
								:per-page="pagination.perPage"
								first-number
								last-number
								class="mb-0 mt-1 mt-sm-0"
								prev-class="prev-item"
								next-class="next-item"
							>
								<template #prev-text>
									<feather-icon icon="ChevronLeftIcon" size="18" />
								</template>
								<template #next-text>
									<feather-icon icon="ChevronRightIcon" size="18" />
								</template>
							</b-pagination>
						</b-col>
					</b-row>
					<b-row class="mb-1">
						<b-col cols="12" xl="7" class="d-flex align-items-center justify-content-start mt-1 mb-md-0">
							<label>Mostrar</label>
							<v-select
								v-model="pagination.perPage"
								:options="perPageOptions"
								:clearable="false"
								class="per-page-selector d-inline-block mx-50"
								style="width: 90px"
							/>
							<label class="mr-2">registros</label>
							<feather-icon class="cursor-pointer" icon="RefreshCcwIcon" size="20" @click="refresh" />
						</b-col>
					</b-row>
					<b-table-simple sticky-header="60vh">
						<b-thead class="text-center">
							<b-tr>
								<b-th>Nombre</b-th>
								<b-th>Estado</b-th>
								<b-th>Activa</b-th>
								<b-th>Fecha de Creación</b-th>
								<b-th>Tracking</b-th>
							</b-tr>
						</b-thead>
						<b-tbody class="text-center">
							<b-tr v-for="row in rows" :key="row.id">
								<b-td>{{ row.name }}</b-td>
								<b-td>
									<b-badge :variant="row.status == 'LIBRE' ? 'success' : 'danger'">
										{{ row.status }}
									</b-badge>
								</b-td>
								<b-td>
									<b-badge pill :variant="'light-' + (row.is_active ? 'success' : 'danger')">
										{{ row.is_active ? "SÍ" : "NO" }}
									</b-badge>
									<b-form-checkbox
										v-model="row.is_active"
										:true-value="1"
										:false-value="0"
										name="check-button"
										switch
										:disabled="row.status == 'OCUPADO'"
										class="mt-1 text-center"
										@change="updateLocationStatus(row)"
										style="margin-left: 0.5rem"
									/>
								</b-td>
								<b-td>
									{{ row.created_at | myGlobalDayWithHour }}
								</b-td>
								<b-td>
									<div class="d-flex justify-content-center" style="gap: 1rem">
										<feather-icon
											size="20"
											icon="ListIcon"
											class="text-primary cursor-pointer"
											@click="openSpecimenLocationTracking(row)"
										/>
									</div>
								</b-td>
							</b-tr>
							<b-tr v-if="rows.length == 0">
								<b-td colspan="4">
									<p class="mb-0">No hay registros por mostrar</p>
								</b-td>
							</b-tr>
						</b-tbody>
					</b-table-simple>
				</b-tab>
			</b-tabs>
		</b-card>
		<b-modal centered v-model="creationModal.show" :title="title" @hidden="handleHidden" size="sm">
			<div>
				Total actual de {{ name }}:
				<span class="font-weight-bold" style="font-size: 1.2rem">
					{{ pagination.total }}
				</span>
			</div>
			<b-form-group :label="`Selecciona la cantidad de ${name} que deseas agregar`" class="mt-1">
				<div class="d-flex justify-content-center align-items-center mt-1">
					<feather-icon
						@click="creationModal.qty > 1 ? creationModal.qty-- : creationModal.qty"
						icon="MinusCircleIcon"
						size="50"
						class="cursor-pointer"
						:class="{ 'text-danger': creationModal.qty == 1, 'text-success': creationModal.qty > 1 }"
					/>
					<div class="container-number bg-primary">
						<p class="mb-0 font-small-4 d-flex justify-content-center align-items-center">
							{{ creationModal.qty }}
						</p>
					</div>

					<feather-icon
						@click="creationModal.qty++"
						icon="PlusCircleIcon"
						size="50"
						class="cursor-pointer text-success"
					/>
				</div>
			</b-form-group>
			<div>
				Total de {{ name }} luego de agregar:
				<span class="font-weight-bold" style="font-size: 1.2rem">
					{{ pagination.total + creationModal.qty }}
				</span>
			</div>
			<template #modal-footer>
				<b-button variant="success" @click="storeLocations">Crear</b-button>
			</template>
		</b-modal>
		<SpecimenLocationTracking
			v-if="showSpecimenLocationTracking"
			:location="selectedLocation"
			@close="showSpecimenLocationTracking = false"
		/>
	</div>
</template>

<script>
import SpecimenLocationService from "@/views/brain/specimens/views/location/services/specimen-location.service.js"
import SpecimenLocationTracking from "@/views/brain/specimens/views/location/components/SpecimenLocationTracking.vue"
export default {
	components: {
		SpecimenLocationTracking,
	},
	data: () => ({
		selectedLocation: null,
		showSpecimenLocationTracking: false,
		isLoading: false,
		tabIndex: 0,
		actualArea: 1,
		areaTabs: [
			{
				id: 1,
				name: "Preparación",
			},
			{
				id: 2,
				name: "Encaste",
			},
		],
		tabs: [
			{
				id: 1,
				name: "Casillas",
			},
			{
				id: 2,
				name: "Rascaderos",
			},
			{
				id: 3,
				name: "Voladeros",
			},
		],
		rows: [],
		creationModal: {
			show: false,
			qty: 1,
			type: null,
		},
		perPageOptions: [10, 25, 50],
		pagination: {
			total: 0,
			curPage: 1,
			perPage: 25,
			from: 0,
			to: 0,
		},
	}),
	computed: {
		title() {
			const titles = {
				1: "Crear Casilla",
				2: "Crear Rascadero",
				3: "Crear Voladero",
			}
			return titles[this.creationModal.type] || "Crear"
		},
		name() {
			const names = {
				1: "casillas(s)",
				2: "rascardero(s)",
				3: "voladero(s)",
			}
			return names[this.creationModal.type]
		},
		counterName() {
			const names = {
				0: "CASILLAS",
				1: "RASCADEROS",
				2: "VOLADEROS",
			}
			return names[this.tabIndex]
		},
	},
	methods: {
		changeArea(areaId) {
			this.actualArea = areaId
			if (this.tabIndex === 0) {
				this.getLocations()
			}
			this.tabIndex = 0
		},
		refresh() {
			this.getLocations()
		},
		openSpecimenLocationTracking(location) {
			this.selectedLocation = location
			this.showSpecimenLocationTracking = true
		},
		async updateLocationStatus(row) {
			const { isConfirmed } = await this.showConfirmSwal({
				title: `¿Estás seguro de que quieres ${row.is_active ? "activar" : "desactivar"} a ${row.name}?`,
				text: "",
			})
			if (!isConfirmed) {
				row.is_active = !row.is_active
				return
			}
			try {
				const { message } = await SpecimenLocationService.switchActive(row.id)
				this.getLocations()
				this.showSuccessToast(message)
			} catch (error) {
				console.log(error)
			} finally {
				this.isPreloading(false)
			}
		},
		async getLocations(page = 1) {
			this.isPreloading(true)
			try {
				const { data } = await SpecimenLocationService.getLocations({
					type_id: this.tabIndex + 1,
					per_page: this.pagination.perPage,
					page: page,
					area_id: this.actualArea,
				})
				this.pagination.curPage = data.current_page
				this.pagination.total = data.total
				this.pagination.from = data.from
				this.pagination.to = data.to
				this.rows = data.data.map((reason) => ({
					...reason,
					is_active: reason.is_active === 1 ? true : false,
				}))
			} catch (error) {
				console.log(error)
			} finally {
				this.isPreloading(false)
			}
		},
		async storeLocations() {
			const { isConfirmed } = await this.showConfirmSwal({
				text: `Se crearan ${this.creationModal.qty} ${this.name}`,
			})

			if (!isConfirmed) return
			this.isPreloading()
			try {
				const res = await SpecimenLocationService.storeLocations({
					qty: this.creationModal.qty,
					type_id: this.tabIndex + 1,
					area_id: this.actualArea,
				})
				this.getLocations()
				this.handleHidden()
				this.showSuccessToast(res.message)
			} catch (error) {
				console.log(error)
			} finally {
				this.isPreloading(false)
			}
		},
		handleOpenCreationModal(type) {
			this.creationModal = {
				show: true,
				qty: 1,
				type,
			}
		},
		handleHidden() {
			this.creationModal = {
				show: false,
				qty: 1,
				type: "",
			}
		},
	},
	watch: {
		tabIndex() {
			this.getLocations()
		},
		"pagination.curPage": async function () {
			await this.getLocations(this.pagination.curPage)
		},
		"pagination.perPage": async function () {
			await this.getLocations()
		},
	},
	mounted() {
		this.getLocations()
	},
}
</script>
<style lang="scss" scoped>
.container-number {
	height: 50px;
	width: 50px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	color: #fff;
	margin: 0 0.1rem;
	p {
		display: flex;
		align-items: center;
		justify-content: center;
		font-weight: bolder !important;
	}
}
.custom-tabs-card-bg {
	background-color: #f0f8ff !important;
	margin: 0 !important;
	padding: 0 !important;
}
</style>
